import { UI_BACKEND_ROOT_URL } from "../constants";

export const initialConfigs = async () => {
    const json = await fetch(`${UI_BACKEND_ROOT_URL}/init`);
    const configs = await json.json();
    return configs;
};
